// How the Dashboard chart follows a filter change for admins and market
// owners. The fetch signature is the base (resource, dates, role, model,
// horizon, comparison models) plus '#' and the sorted selection ids, so the
// base of the applied signature can be read back. Ensemble is ENSEMBLE_ID: it
// arrives with the market forecasts and is never fetched on its own.
export const ENSEMBLE_ID = 'ensemble';

export const buildFetchSignature = (base, selectedIds) => `${base}#${[...selectedIds].sort().join(',')}`;

export const signatureBase = (signature) => {
  const at = signature ? signature.lastIndexOf('#') : -1;
  return at < 0 ? null : signature.slice(0, at);
};

// appliedBase: base of what the chart shows (null when nothing is shown).
// selectedIds: the selection, in order. loadedIds: forecasters loaded or loading.
//   'full'  the base changed: refetch everything; `add` is the whole selection
//   'add'   fetch only `add` and drop `remove` locally
//   'local' nothing to fetch: drop `remove` (empty for an Ensemble toggle)
export function planForecasterFetch({ appliedBase, nextBase, selectedIds, loadedIds }) {
  const wanted = selectedIds.filter((id) => id !== ENSEMBLE_ID);
  if (appliedBase == null || appliedBase !== nextBase) return { kind: 'full', add: wanted, remove: [] };
  const add = wanted.filter((id) => !loadedIds.includes(id));
  const remove = loadedIds.filter((id) => !wanted.includes(id));
  return { kind: add.length > 0 ? 'add' : 'local', add, remove };
}
